'use client';

import { c as _c } from "react/compiler-runtime";
import type { DehydratedState } from '@tanstack/react-query';
import { NavigationGuardProvider } from 'next-navigation-guard';
import type { ReactNode } from 'react';
import { AuthProvider, type ServerAuthData } from '@/app/_auth/useAuth';
import { TrpcProvider } from '@/app/_trpc/TrpcProvider';
export function GlobalProviders(t0) {
  const $ = _c(8);
  const {
    children,
    dehydratedState,
    serverAuth
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NavigationGuardProvider>{children}</NavigationGuardProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== serverAuth || $[3] !== t1) {
    t2 = <AuthProvider serverAuth={serverAuth}>{t1}</AuthProvider>;
    $[2] = serverAuth;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dehydratedState || $[6] !== t2) {
    t3 = <TrpcProvider dehydratedState={dehydratedState}>{t2}</TrpcProvider>;
    $[5] = dehydratedState;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}